/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ForgotLicensingPasswordError = "CODEDELIVERYFAILED" | "INVALIDINPUT" | "UNKNOWNERROR" | "USERNOTCONFIRMED" | "%future added value";
export type ForgotLicensingPasswordInput = {
    email?: string | null | undefined;
};
export type sendForgotPasswordMutationVariables = {
    input: ForgotLicensingPasswordInput;
};
export type sendForgotPasswordMutationResponse = {
    readonly forgotLicensingPassword: {
        readonly wasSuccessful: boolean | null;
        readonly deliveryMedium: string | null;
        readonly errors: ReadonlyArray<{
            readonly errorCode: ForgotLicensingPasswordError;
            readonly message: string;
        } | null> | null;
    } | null;
};
export type sendForgotPasswordMutation = {
    readonly response: sendForgotPasswordMutationResponse;
    readonly variables: sendForgotPasswordMutationVariables;
};



/*
mutation sendForgotPasswordMutation(
  $input: ForgotLicensingPasswordInput!
) {
  forgotLicensingPassword(input: $input) {
    wasSuccessful
    deliveryMedium
    errors {
      errorCode
      message
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ForgotLicensingPassword",
            "kind": "LinkedField",
            "name": "forgotLicensingPassword",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "wasSuccessful",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deliveryMedium",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "DetailedErrorOfForgotLicensingPassword",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "errorCode",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "sendForgotPasswordMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "sendForgotPasswordMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "e3a7f0fc47c0a7300abd04b42101065a",
            "id": null,
            "metadata": {},
            "name": "sendForgotPasswordMutation",
            "operationKind": "mutation",
            "text": "mutation sendForgotPasswordMutation(\n  $input: ForgotLicensingPasswordInput!\n) {\n  forgotLicensingPassword(input: $input) {\n    wasSuccessful\n    deliveryMedium\n    errors {\n      errorCode\n      message\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'f44145fc264fe20402b71cdb58d96e8f';
export default node;
